module.exports = __webpack_public_path__ + "img/case-icon.1b23f970.png";